import "./css/Layout.css";
import logga from "../assets/logga.png";
import { useState } from "react";
import { Link } from "react-router-dom";

function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <header className="header">
            <Link to="/" className="logo-link">
                <h1>gUDfADDerieT</h1>
            </Link>    

            <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)}>
                    ☰
            </button>

                
            <nav className= {`menu ${menuOpen ? "open" : ""}`}>
                <Link to = "/">Hem</Link>
                <Link to = "/information">InFOrmatiOn</Link>
                <Link to = "/schema">ScHema</Link>
                {/*<Link to = "/Event">evenT</Link>*/}
                <Link to = "/n0llehandboken">N0lleHandbOkeN</Link>
            </nav>
            
        </header>
    );
}

function Footer() {
    return (
        <footer className="footer">
            <img src={logga} alt="Gudfadderiet" className="logo" />

            <p> 
                <span className="viking-font"> gUDfADDerieT</span> ser dig alltid,
                <span className="viking-font"> N0llan</span>.
            </p>

        </footer>
    );
}

export { Header, Footer };